module.exports = __webpack_public_path__ + "static/logoUE-8e7f6cdbdfa11e9c3721fe31ad011519.svg";